import { BaseElectionPost } from "./base/BaseElectionPost";
import { convertirFecha } from "../utils/dataFormatter";

export class BalotajePost extends BaseElectionPost {
  constructor() {
    super({
      electionType: 'balotaje',
      thresholds: { low: 100, medium: 100, high: 100 } // Para balotaje siempre usa Initial
    });
  }

  /**
   * IMPORTANTE: Balotaje tiene lógica especial por hora del día
   * Siempre usa createInitialContent pero cambia según la hora
   */
  createInitialContent(data, params) {
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = this.formatProvinciaLocalidad(data.provinciaLocalidad);
    const extras = params.menu?.elecciones?.item?.items?.[0]?.extras;
    
    // Obtener hora de Argentina
    const date = new Date();
    const argTime = new Intl.DateTimeFormat('en-US', { 
      hour: '2-digit', 
      minute: '2-digit', 
      hour12: false, 
      timeZone: 'America/Argentina/Buenos_Aires' 
    }).format(date);
    
    const hour = parseInt(argTime.split(':')[0]);
    
    // Determinar variante según la hora
    if (hour < 14) {
      return this.createMorningContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras);
    } else if (hour >= 14 && hour < 18) {
      return this.createAfternoonContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras);
    } else {
      return this.createEveningContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras);
    }
  }

  /**
   * Versión mañana: Antes de las 14hs
   */
  createMorningContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras) {
    const newsSeo = (extras?.liveblog_bajadaSEO && extras?.leyenda_bajadaSEO) 
      ? [{ value: { url: extras?.liveblog_bajadaSEO }, title: extras?.leyenda_bajadaSEO }] 
      : [];
    
    const freeText = extras?.parrafo 
      ? { type: "text", value: `<p>${extras?.parrafo}</p>` } 
      : { type: "text", value: `` };

    return {
      title: `Resultados de las Elecciones 2023 para Presidente en ${formatedProvinciaLocalidad}: se define el balotaje entre Sergio Massa y Javier Milei`,
      summary: `
        <ul>
          <li>Los argentinos eligen en segunda vuelta al nuevo Presidente.</li>
          <li>El escrutinio minuto a minuto, el mapa y todo lo que tenés que saber.</li>                
        </ul>`,
      newsSeo: newsSeo,
      subtitle: "",
      description: "",
      publishedDate: "2023-11-19T13:00:00.000Z",
      formattedPublishedDate: "19 NOV 2023",
      lastModified: "Sun, 19 Nov 2023 13:00:00 GMT",
      gtmPublishedDate: "2023-11-19T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Los ciudadanos de <strong>${formatedProvinciaLocalidad}</strong> eligen hoy al nuevo Presidente argentino y hay gran expectativa por los <strong>resultados</strong> de las <strong>Elecciones 2023</strong> entre <strong>Sergio Massa</strong> y <strong>Javier Milei</strong>. Horas después de las 18 se conocerá <strong>quién ganó el balotaje</strong> y qué fórmula gobernará los próximos cuatro años en la Argentina.</p>`
        },
        {
          type: "text",
          value: `<p>El desempate electoral consagrará a la fórmula que logre la mayor cantidad de votos afirmativos válidamente emitidos. En la segunda vuelta de este domingo sólo se eligen los máximos cargos ejecutivos, ya que senadores y diputados fueron elegidos en la primera ronda.</p>`
        },
        freeText,
        {
          type: "text",
          value: `<p>Seguí toda la información del escrutinio de las Elecciones y el mapa nacional, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<h2>Resultados Elecciones 2023: quién ganó en las generales del 22 de octubre</h2>`
        },
        {
          type: "text",
          value: `<ul>
            <li>Sergio Massa (36,78% de los votos)</li>
            <li>Javier Milei (29,99%)</li>
            <li>Patricia Bullrich (23,81%)</li>
            <li>Juan Schiaretti (6,73%)</li>
            <li>Myriam Bregman (2,70%)</li>
          </ul>`
        },
        {
          type: "text",
          value: `<p>Los datos corresponden al <a href="https://www.clarin.com/politica/termino-escrutinio-definitivo-quedo-diferencia-massa-milei_0_6YLPlwjnmh.html">escrutinio definitivo</a> publicado por la Justicia Electoral sobre las elecciones del pasado domingo 22 de octubre. El balotaje se confirmó una vez que ningún candidato obtuvo el 45% de los sufragios o más del 40% con diez puntos de diferencia sobre el segundo.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/voto-elecciones-2023-consulta-padron-electoral-balotaje_0_WqLxvGDp38.html" target="_blank">Dónde voto en ${formatedProvinciaLocalidad}: consultá el padrón electoral para el balotaje 2023</a></h2>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">Elecciones 2023: qué pasa si no voto</a></h2>`
        },
        {
          type: "text",
          value: `<p>En el <strong>padrón electoral</strong> figura <strong>el lugar</strong> donde se debe sufragar, el <strong>número de mesa y el número de orden</strong>, con el objetivo de que los votantes les brinden esa información a las autoridades de mesa y que la votación sea más ágil y práctica. Para chequear los datos del padrón, hay que ingresar en el link dispuesto arriba y así conocer dónde votar.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/boca-urna-elecciones-2023-funciona_0_VlXXeWJLZ6.html" target="_blank">¿Qué es el boca de urna y a qué hora se conocerán los primeros resultados oficiales?</a></h2>`
        },
        {
          type: "text",
          value: `<p><strong>Boca de urna</strong> es uno de los términos más buscados tanto en redes sociales como en Google a la hora de anticiparse a los <strong>resultados oficiales</strong> de cada elección. Se trata de encuestas que se realizan a la salida de los establecimientos electorales luego de que los votantes emitieron su sufragio. Los medios de comunicación no pueden publicar estas cifras porque <strong>la ley nacional Nº 25.610 prohíbe cualquier tipo de difusión masiva de datos</strong> hasta tres horas posteriores a un acto electoral.</p>`
        },
        {
          type: "text",
          value: `<p>Los primeros resultados oficiales podrían comenzar a difundirse a partir de 21, según confirmó la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/cuenta-voto-blanco-balotaje-argentina-2023_0_OryqR95Oo4.html" target="_blank">Cómo se cuenta el voto en blanco en este balotaje</a></h2>`
        },
        {
          type: "text",
          value: `<p>Una de las dudas más frecuentes es cómo funciona el <strong>voto en blanco</strong>. El voto en blanco es considerado válido, pero no afirmativo para ninguno de los candidatos. Se considera voto en blanco a todo sobre que esté vacío o que contenga un papel de cualquier color, sin inscripciones ni imágenes.</p>`
        },
        {
          type: "text",
          value: `<p>Aunque el <strong>voto en blanco</strong> y el voto nulo tienen diferencias, en el <strong>balotaje de 2023</strong> no se contabilizan, ya que la <strong>Constitución Nacional</strong> establece que la victoria presidencial se define por "los votos afirmativos válidamente emitidos". La clave: el voto en blanco y el voto nulo no benefician a ningún candidato en particular ni afectan el resultado aunque ayudan de manera indirecta a mantener la ventaja de quien lidere la primera posición.</p>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * Versión tarde: Entre 14hs y 18hs
   */
  createAfternoonContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras) {
    const newsSeo = (extras?.liveblog_bajadaSEO && extras?.leyenda_bajadaSEO) 
      ? [{ value: { url: extras?.liveblog_bajadaSEO }, title: extras?.leyenda_bajadaSEO }] 
      : [];
    
    const freeText = extras?.parrafo 
      ? { type: "text", value: `<p>${extras?.parrafo}</p>` } 
      : null;

    return {
      title: `Resultados de las Elecciones 2023 para Presidente en ${formatedProvinciaLocalidad}: a qué hora se conocerán los primeros datos oficiales`,
      summary: `
        <ul>
          <li>La segunda vuelta se define entre Sergio Massa y Javier Milei.</li>
          <li>El escrutinio minuto a minuto, el mapa y todo lo que tenés que saber.</li>
        </ul>`,
      newsSeo: newsSeo,
      subtitle: "",
      description: "",
      publishedDate: "2023-11-19T13:00:00.000Z",
      formattedPublishedDate: "19 NOV 2023",
      lastModified: "Sun, 19 Nov 2023 13:00:00 GMT",
      gtmPublishedDate: "2023-11-19T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Los ciudadanos de <strong>${formatedProvinciaLocalidad}</strong> eligen hoy al nuevo Presidente argentino y hay gran expectativa por los <strong>resultados</strong> de las <strong>Elecciones 2023</strong> entre <strong>Sergio Massa</strong> y <strong>Javier Milei</strong>. A partir de las 21 podrán comenzar a difundirse los primeros resultados oficiales y se conocerá <strong>quién ganó el balotaje</strong> y qué fórmula gobernará los próximos cuatro años en la Argentina. Seguí toda la información del escrutinio de las <strong>Elecciones</strong> y el mapa nacional, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<p>El desempate electoral consagrará a la fórmula que logre la mayor cantidad de votos afirmativos válidamente emitidos. En la segunda vuelta de este domingo sólo se eligen los máximos cargos ejecutivos, ya que senadores y diputados fueron elegidos en la primera ronda.</p>`
        },
        freeText,
        {
          type: "text",
          value: `<h2>Resultados Elecciones 2023: quién ganó en las generales del 22 de octubre</h2>`
        },
        {
          type: "text",
          value: `<ul>
            <li>Sergio Massa (36,78% de los votos)</li>
            <li>Javier Milei (29,99%)</li>
            <li>Patricia Bullrich (23,81%)</li>
            <li>Juan Schiaretti (6,73%)</li>
            <li>Myriam Bregman (2,70%)</li>
          </ul>`
        },
        {
          type: "text",
          value: `<p>Los datos corresponden al <a href="https://www.clarin.com/politica/termino-escrutinio-definitivo-quedo-diferencia-massa-milei_0_6YLPlwjnmh.html">escrutinio definitivo</a> publicado por la Justicia Electoral sobre las elecciones del pasado domingo 22 de octubre. El balotaje se confirmó una vez que ningún candidato obtuvo el 45% de los sufragios o más del 40% con diez puntos de diferencia sobre el segundo.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/cuenta-voto-blanco-balotaje-argentina-2023_0_OryqR95Oo4.html" target="_blank">Resultados Elecciones 2023: cómo se cuenta el voto en blanco en este balotaje</a></h2>`
        },
        {
          type: "text",
          value: `<p>Una de las dudas más frecuentes es cómo funciona el <strong>voto en blanco</strong>. El blanco es considerado válido, pero no afirmativo para ninguno de los candidatos. Se considera voto en blanco a todo sobre que esté vacío o que contenga un papel de cualquier color, sin inscripciones ni imágenes.</p>`
        },
        {
          type: "text",
          value: `<p>Aunque el <strong>voto en blanco</strong> y el voto nulo tienen diferencias, en el balotaje de 2023 no se contabilizan, ya que la Constitución Nacional establece que la victoria presidencial se define por "los votos afirmativos válidamente emitidos". <strong>La clave</strong>: el voto en blanco y el voto nulo no benefician a ningún candidato en particular ni afectan el resultado aunque <strong>ayudan de manera indirecta</strong> a mantener la ventaja de quien lidera la primera posición.</p>`
        },
        {
          type: "text",
          value: `<h2>Qué es el boca de urna y cómo debe usarse el día de la elección</h2>`
        },
        {
          type: "text",
          value: `<p><strong>Boca de urna</strong> es uno de los términos más buscados tanto en redes sociales como en Google a la hora de anticiparse a los <strong>resultados oficiales</strong> de cada elección. Se trata de encuestas que se realizan a la salida de los establecimientos electorales luego de que los votantes emitieron su sufragio. Los medios de comunicación no pueden publicar estas cifras porque <strong>la ley nacional Nº 25.610 prohíbe cualquier tipo de difusión masiva de datos</strong> hasta tres horas posteriores a un acto electoral.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/voto-elecciones-2023-consulta-padron-electoral-balotaje_0_WqLxvGDp38.html" target="_blank">Dónde voto en ${formatedProvinciaLocalidad}: consultá el padrón electoral para el balotaje 2023</a></h2>`
        },
        {
          type: "text",
          value: `<p>En el <strong>padrón electoral</strong> figura <strong>el lugar</strong> donde se debe sufragar, el <strong>número de mesa y el número de orden</strong>, con el objetivo de que los votantes les brinden esa información a las autoridades de mesa y que la votación sea más ágil y práctica. Para chequear los datos del padrón, hay que ingresar en el link dispuesto arriba y así poder chequear la información.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/multa-votar-balotaje-2023-dia-puede-pagar_0_sapHtp3dyx.html" target="_blank">Multa por no votar en el balotaje: dónde y hasta qué día se puede pagar</a></h2>`
        },
        {
          type: "text",
          value: `<p>Quienes no voten <strong>tienen hasta 60 días</strong> para presentar una justificación ante la Justicia Electoral y evitar <strong>multas</strong> económicas y administrativas. De lo contrario, se les aplicará una <strong>sanción</strong> que a su vez constará automáticamente en el Registro de Infractores. Para consultar si se adeuda alguna multa de anteriores elecciones hay que dirigirse a la web de la Cámara Nacional Electoral (CNE) e ingresar a la categoría "Registro de Infractores".</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/asume-nuevo-presidente-argentina-elecciones-2023_0_8mNcOwMDyd.html" target="_blank">Elecciones 2023: ¿cuándo asume el nuevo Presidente?</a></h2>`
        },
        {
          type: "text",
          value: `<p>El nuevo <strong>Presidente</strong> asumirá su cargo el 10 de diciembre, en reemplazo de Alberto Fernández. Coincidentemente, ese día se cumplirán 40 años de democracia ininterrumpidos en la Argentina, luego de que Raúl Alfonsín iniciara su mandato en 1983.</p>`
        }
      ].filter(Boolean),
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * Versión noche: Después de las 18hs
   */
  createEveningContent(data, fechasFormateadas, formatedProvinciaLocalidad, extras) {
    const newsSeo = (extras?.liveblog_bajadaSEO && extras?.leyenda_bajadaSEO) 
      ? [{ value: { url: extras?.liveblog_bajadaSEO }, title: extras?.leyenda_bajadaSEO }] 
      : [];
    
    const freeText = extras?.parrafo 
      ? { type: "text", value: `<p>${extras?.parrafo}</p>` } 
      : null;

    return {
      title: `Resultados de las Elecciones 2023 para Presidente en ${formatedProvinciaLocalidad}: quién gana el balotaje para Presidente`,
      summary: `
        <ul>
          <li>Entre Sergio Massa y Javier Milei se define quién será el nuevo Presidente de la Nación.</li>
          <li>El escrutinio minuto a minuto, el mapa y todo lo que tenés que saber.</li>
        </ul>`,
      newsSeo: newsSeo,
      subtitle: "",
      description: "",
      publishedDate: "2023-11-19T13:00:00.000Z",
      formattedPublishedDate: "19 NOV 2023",
      lastModified: "Sun, 19 Nov 2023 13:00:00 GMT",
      gtmPublishedDate: "2023-11-19T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Los ciudadanos de <strong>${formatedProvinciaLocalidad}</strong> esperan por los <strong>resultados</strong> de las <strong>Elecciones 2023</strong> entre <strong>Sergio Massa</strong> y <strong>Javier Milei</strong>, que definirán al nuevo <strong>Presidente de la Nación</strong>. Cada vez falta menos para conocer <strong>quién ganó el balotaje</strong> y qué fórmula gobernará los próximos cuatro años en la Argentina. Seguí toda la información del escrutinio de las <strong>Elecciones</strong> y el mapa nacional, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<p>El <strong>futuro Presidente</strong> asumirá su cargo el 10 de diciembre, en reemplazo de Alberto Fernández. Coincidentemente, ese día se cumplirán 40 años de democracia ininterrumpidos en la Argentina, luego de que Raúl Alfonsín iniciara su mandato en 1983.</p>`
        },
        freeText,
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/politica/cuenta-voto-blanco-balotaje-argentina-2023_0_OryqR95Oo4.html" target="_blank">Cómo se cuenta el voto en blanco en este balotaje</a></h2>`
        },
        {
          type: "text",
          value: `<p>Una de las dudas más frecuentes es cómo funciona el voto en blanco. El blanco es considerado válido, pero no afirmativo para ninguno de los candidatos. Se considera voto en blanco a todo sobre que esté vacío o que contenga un papel de cualquier color, sin inscripciones ni imágenes.</p>`
        },
        {
          type: "text",
          value: `<p>Aunque el <strong>voto en blanco</strong> y el voto nulo tienen diferencias, en el balotaje de 2023 no se contabilizan, ya que la Constitución Nacional establece que la victoria presidencial se define por "los votos afirmativos válidamente emitidos". <strong>La clave</strong>: el voto en blanco y el voto nulo no benefician a ningún candidato en particular ni afectan el resultado aunque <strong>ayudan de manera indirecta</strong> a mantener la ventaja de quien lidera la primera posición.</p>`
        },
        {
          type: "text",
          value: `<h2>Qué es el boca de urna y cómo debe usarse el día de la elección</h2>`
        },
        {
          type: "text",
          value: `<p><strong>Boca de urna</strong> es uno de los términos más buscados tanto en redes sociales como en Google a la hora de anticiparse a los <strong>resultados oficiales</strong> de cada elección. Se trata de encuestas que se realizan a la salida de los establecimientos electorales luego de que los votantes emitieron su sufragio.</p>`
        },
        {
          type: "text",
          value: `<p>Los medios de comunicación no pueden publicar estas cifras porque <strong>la ley nacional Nº 25.610 prohíbe cualquier tipo de difusión masiva de datos</strong> hasta tres horas posteriores a un acto electoral.</p>`
        },
        {
          type: "text",
          value: `<p>Los datos corresponden al <a href="https://www.clarin.com/politica/termino-escrutinio-definitivo-quedo-diferencia-massa-milei_0_6YLPlwjnmh.html">escrutinio definitivo</a> publicado por la Justicia Electoral sobre las elecciones del pasado domingo 22 de octubre. El balotaje se confirmó una vez que ningún candidato obtuvo el 45% de los sufragios o más del 40% con diez puntos de diferencia sobre el segundo.</p>`
        },
        {
          type: "text",
          value: `<h2>Qué son las mesas testigo</h2>`
        },
        {
          type: "text",
          value: `<p>Las mesas testigo son elegidas por los partidos políticos para tener una proyección propia sobre los resultados de las elecciones. Los cómputos son suministrados por los fiscales de mesa y dan una idea aproximada de cómo avanza el escrutinio a nivel general.</p>`
        },
        {
          type: "text",
          value: `<h2>Resultados Elecciones 2023: quién ganó en las generales del 22 de octubre</h2>`
        },
        {
          type: "text",
          value: `<ul>
            <li>Sergio Massa (36,78% de los votos)</li>
            <li>Javier Milei (29,99%)</li>
            <li>Patricia Bullrich (23,81%)</li>
            <li>Juan Schiaretti (6,73%)</li>
            <li>Myriam Bregman (2,70%)</li>
          </ul>`
        },
        {
          type: "text",
          value: `<p>Los datos corresponden al escrutinio definitivo publicado por la Justicia Electoral sobre las elecciones del pasado domingo 22 de octubre.</p>`
        }
      ].filter(Boolean),
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  // Los otros métodos no se usan en balotaje pero deben existir
  createEarlyContent(data, params) {
    return this.createInitialContent(data, params);
  }

  createPartialContent(data, params) {
    return this.createInitialContent(data, params);
  }

  createFinalContent(data, params) {
    return this.createInitialContent(data, params);
  }

  /**
   * Helpers específicos
   */
  formatProvinciaLocalidad(cadena) {
    const partes = cadena.split(", ");
    if (partes.length === 2) {
      const [provincia, localidad] = partes;
      return `${localidad}, ${provincia}`;
    }
    return cadena;
  }

  getSections() {
    return [
      {
        _id: 15006,
        name: "Información General",
        url: "informacion-general",
        nsSite: "",
        autoplay: false,
        metadata: {}
      }
    ];
  }

  getMetadata() {
    return {
      typeWeb: "small",
      origin: "default",
      payWallAccessControl: "freemium",
      sponsored: false,
      accessProduct: "CLARIN_D",
      canHaveAmp: true,
      canHaveComments: true,
      autoRefresh: true,
      titleEnable: false,
      footer_visible: true,
      ualterDisabled: false,
      trinityDisabled: false,
      disabledTimelineLiveblog: false,
      featuredContent: false,
      stopWords: true
    };
  }

  getTags(params) {
    return [
      { name: "Elecciones 2023", slug: "elecciones-2023", subject: "subject", _id: "VyFmuMo-2" },
      { name: "Balotaje", slug: "balotaje", subject: "subject" },
      { name: "Sergio Massa", slug: "sergio-massa" },
      { name: "Javier Milei", slug: "javier-milei" }
    ];
  }

  generateMeta(content, data, params) {
    const title = content?.title || `Balotaje 2023: Resultados Elecciones Presidente`;
    const description = this.extractDescription(content) || 
                       `Resultados del balotaje 2023 entre Sergio Massa y Javier Milei`;
    const imageUrl = this.getImage(params.codeLetter);

    return {
      description,
      title,
      keywords: `Balotaje, Elecciones 2023, Sergio Massa, Javier Milei, Presidente, Resultados`,
      url: params.baseUrl,
      urlImage: imageUrl,
      extra: [
        { name: "title", content: title },
        { name: "description", content: description },
        { name: "distribution", content: "global" },
        { name: "robots", content: "max-image-preview:large" },
        { property: "og:image", content: imageUrl },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "article:published_time", content: "2023-11-19T13:00:00.000Z" },
        { property: "article:modified_time", content: data.last_update }
      ]
    };
  }

  extractDescription(content) {
    return content?.description || 
           content?.body?.[0]?.value?.replace(/<[^>]*>/g, '')?.trim();
  }
}